import { render, staticRenderFns } from "./infoChamada.vue?vue&type=template&id=2dd9219e&scoped=true"
import script from "./infoChamada.vue?vue&type=script&lang=js"
export * from "./infoChamada.vue?vue&type=script&lang=js"
import style0 from "./infoChamada.vue?vue&type=style&index=0&id=2dd9219e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9219e",
  null
  
)

export default component.exports